import { TFunction } from "react-i18next";

export const getAppResourceTypeListOptions = (t: TFunction) => ({
	PRODUCT: t("enums.apps.resource_types.PRODUCT"),
	CONTACT: t("enums.apps.resource_types.CONTACT"),
	PRODUCT_CATEGORY: t("enums.apps.resource_types.PRODUCT_CATEGORY"),
	STOCK: t("enums.apps.resource_types.STOCK"),
});
